<template>
    <div class="container">
        <div class="card">
            <div v-if="msgExt.length > 0">
                <div class="title">本次小结</div>
                <div v-for="(item,index) of msgExt" :key="index">
                    <div class="desc"><div class="char_style">“&nbsp</div><div>{{item.descValue}}</div></div>
                    <div class="value_container">
                        <div class="item_desc">翻译次数</div>
                        <div class="value">{{item.transTimesCount}}次</div>

                        <div class="item_desc">翻译字符数</div>
                        <div class="value">{{item.transWordCount}}字符</div>

                        <div class="item_desc">使用时长</div>
                        <div class="value">{{item.time}}分钟</div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="title">继续努力哟</div>
            </div>
            <div class="bottom_title">
                腾讯翻译君
            </div>
        </div>
    </div>

</template>


<!--&lt;!&ndash;测试版本&ndash;&gt;-->
<!--<script src="https://static.module.watch.okii.com/watch/api/xtcJSBridge.js"></script>-->
<!--&lt;!&ndash;正式版本&ndash;&gt;-->
<!--<script src="https://static.watch.okii.com/watch/api/xtcJSBridge.js"></script>-->
<!--{"transTimesCount": 0, "transWordCount": 0, "time": 2.8, "descValue": "萤火虫的光点虽然微弱，但亮着便是向黑暗挑战"}-->
<script>

    import Vue from 'vue'
    import secret from '../js/secret'
    // import VConsole from 'vconsole'

    export default {
        name: 'Summary',
        data: function () {

            return {
                msgExt: [

                ]
            }
        },
        mounted() {
            // let recaptchaScript = document.createElement('script');
            // recaptchaScript.setAttribute('src', 'https://static.module.watch.okii.com/watch/api/xtcJSBridge.js');
            // document.head.appendChild(recaptchaScript);

            // let _this = this;
            // let timestamp = new Date().getTime().toString();
            // let encryptList = [];
            // let openIdList = ['16057a8db2024939a0bd0dc7f992ca8f', "1223"];
            // for (let index = 0; index < openIdList.length; index++) {
            //     let encryptId = secret.Encrypt(openIdList[index]);
            //     window.console.log('encrypt data item=== ' + encryptId);
            //     encryptList = encryptList.concat(encryptId);
            // }
            // window.console.log('encrypt data === ' + encryptList.length);
            // Vue.axios.post('http://translatorwatch.sparta.html5.qq.com/appserver/push/web/fetch',
            //     {
            //         "appId": "uYJDovQ7Mt1JnqRX",
            //         'data': {
            //             "openId": encryptList
            //         }
            //     },
            //     {'headers': {'WATCH_DD': 'uYJDovQ7Mt1JnqRX', 'WATCH_TT': secret.Encrypt(timestamp)}})
            //     .then(function (response) {
            //         window.console.log(response);
            //         window.console.log(response.data);
            //         if (response.data && response.data.data && response.data.data &&
            //             response.data.data.length > 0) {
            //             let userMsgList = response.data.data;
            //             window.console.log('data size ===' + JSON.stringify(userMsgList));
            //
            //             let msgExtArray = [];
            //             for (let index = 0; index < userMsgList.length; index++) {
            //
            //                 let userItem = userMsgList[index];
            //                 window.console.log('each item ===' + index + " : " + JSON.stringify(userItem));
            //                 if (userItem && userItem.msgList.length > 0) {
            //                     let firstMsg = userItem.msgList[0];
            //                     let msgExt = firstMsg.msgExt;
            //                     window.console.log('data json===' + JSON.stringify(msgExt));
            //                     if (msgExt) {
            //                         let timeLength = msgExt.useTimeLength;
            //                         window.console.log('data json===timeLength=' + timeLength);
            //                         msgExt.time = (timeLength / 1000 / 60).toFixed(2);
            //
            //                         window.console.log('data json===' + JSON.stringify(msgExt));
            //                         msgExtArray = msgExtArray.concat(msgExt);
            //                         window.console.log('data json===' + JSON.stringify(msgExtArray));
            //                     }
            //                 }
            //
            //             }
            //             _this.msgExt = msgExtArray
            //         }
            //     }).catch(function (error) {
            //     window.console.log('error === ' + error);
            // });
        },
        beforeMount() {
            //请求网络时机
            // const vConsole = new VConsole();
            // window.console.log(vConsole.version)
            window.console.log('=== before mount typeof xtc ===' + typeof xtc);
            let _this = this;
            window.xtc.getOpenId({
                // 调试appId值为39a476cd5cbac50b1ba2435578
                appId: '100033',
                complete: function (res) {
                    window.console.log(res); // 调用成功、失败都会执行
                },
                success: function (data) {
                    window.console.log('success callback ==== ' + data); // 调用成功后执行
                    // {"openId":["xxxxxxxxxxx","xxxxxxxxxxx"]}
                    //这里获取openID对应的push消息，只获取最新的一条
                    let openIdList = data.openId;
                    let timestamp = new Date().getTime().toString();
                    if (openIdList && openIdList.length > 0) {

                        let encryptList = [];
                        for (let index = 0; index < openIdList.length; index++) {
                            let encryptId = secret.Encrypt(openIdList[index]);
                            encryptList = encryptList.concat(encryptId);
                        }
                        window.console.log('load data from server === ' + encryptList.toString());
                        Vue.axios.post('https://watchserver.translator.qq.com/appserver/push/web/fetch',
                            {
                                "appId": "uYJDovQ7Mt1JnqRX",
                                'data': {
                                    "openId": encryptList
                                }
                            },
                            {'headers': {'WATCH_DD': 'uYJDovQ7Mt1JnqRX', 'WATCH_TT': secret.Encrypt(timestamp)}})
                            .then(function (response) {
                                window.console.log(response);
                                window.console.log(response.data);
                                if (response.data && response.data.data && response.data.data &&
                                    response.data.data.length > 0) {
                                    let userMsgList = response.data.data;
                                    window.console.log('data size ===' + JSON.stringify(userMsgList));

                                    let msgExtArray = [];
                                    for (let index = 0; index < userMsgList.length; index++) {

                                        let userItem = userMsgList[index];
                                        window.console.log('each item ===' + index + " : " + JSON.stringify(userItem));
                                        if (userItem && userItem.msgList.length > 0) {
                                            let firstMsg = userItem.msgList[0];
                                            let msgExt = firstMsg.msgExt;
                                            window.console.log('data json===' + JSON.stringify(msgExt));
                                            if (msgExt) {
                                                let timeLength = msgExt.useTimeLength;
                                                window.console.log('data json===timeLength=' + timeLength);
                                                msgExt.time = (timeLength / 1000 / 60).toFixed(2);

                                                window.console.log('data json===' + JSON.stringify(msgExt));
                                                msgExtArray = msgExtArray.concat(msgExt);
                                                window.console.log('data json===' + JSON.stringify(msgExtArray));
                                            }
                                        }

                                    }
                                    _this.msgExt = msgExtArray
                                }
                            }).catch(function (error) {
                            window.console.log('error === ' + error);
                            // _this.msgExt = {name: 'err data', age: 11, ext: {a: 'err_data_a', b: 'err_data_b'}}
                        });
                    }
                },
                fail: function (data, code) {
                    window.console.log('fail callback === ' + data); // 调用失败后执行
                    window.console.log(code);
                }
            });
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .title {
        font-size: 1.5em;
        color: #000000;
    }

    .char_style {
        color: #dfbb85;
        font-weight: bold;
        font-size: 1.2em;
        font-family: Charter, sans-serif;
        padding-right: 10px;
    }

    .desc {
        color: #dfbb85;
        font-weight: bold;
        font-size: 1.2em;
        margin-top: 1rem;
        text-align: left;
        padding-left: 30px;
        padding-right: 50px;
        display: flex;
        align-items: flex-start;
    }

    .value {
        color: #555555;
        font-weight: bold;
        font-size: 1rem;
    }

    .item_desc {
        color: #b7b7b7;
        font-weight: bold;
        margin-top: 1rem;
        font-size: 0.8rem;
    }

    .container {
        position: relative;
    }

    .card {
        position: absolute;
        width: 80%;
        top: 12vh;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        padding-top: 20px;
        padding-bottom: 20px;
        border-radius: 5px;
        box-shadow:#e2e2e2 0 0 15px;
    }

    .value_container {
        margin-top: 1rem;
        text-align: left;
        padding-left: 50px;
        padding-right: 50px;
    }

    .bottom_title {
        color: #b7b7b7;
        font-weight: bold;
        margin-top: 5rem;
        font-size: 0.8rem;
    }
</style>
